import React, { ReactElement } from 'react';
import { Table, Section } from '../../common';
import { DefinitionList } from '../components/DefinitionList';
import './ActionRow.css';

interface ActionRowProps {
	actionRef?: React.RefObject<any>;
	actionCell?: any;
	actions?: ReactElement;
	children?: any;
}

interface ActionRowState {
	open: boolean;
}

export default class ActionRow extends React.Component<ActionRowProps, ActionRowState> {

	toolbarRef: React.RefObject<any>;

	constructor(props) {
		super(props);
		this.state = {
			open: false
		};

		this.toolbarRef = React.createRef();
	}

	render() {
		return (
				<>
				{this.props.actions &&
				<>
						<Section
							title={this.props.actionCell}
							type="em-c-section--expandable"
							titleMarginBottom="none"
							marginNone
							titleAlignStart
						>
							<DefinitionList className="custom-actionRow-alignment">
									<DefinitionList.Item>
										<div className="em-c-toolbar" ref={this.toolbarRef}>
											{this.props.actions}
										</div>
									</DefinitionList.Item>
							</DefinitionList>
						</Section>
				</>}
				{this.props.children}
			</>
		);
	}
}